import React from 'react';
import { Award, Shield, Users } from 'lucide-react';
import { motion } from 'framer-motion';
import { SectionHeading } from './ui/SectionHeading';
const reasons = [{
  icon: Award,
  title: 'Expert Local Guides',
  description: 'Our team consists of certified Sherpa guides with decades of experience in high-altitude trekking and deep local knowledge.',
  color: 'from-blue-400 to-blue-600'
}, {
  icon: Shield,
  title: 'Safety First',
  description: 'Your safety is our priority. We carry comprehensive medical kits, oxygen cylinders, and have 24/7 helicopter rescue protocols.',
  color: 'from-purple-400 to-purple-600'
}, {
  icon: Users,
  title: 'Small Groups',
  description: 'We keep our groups small (max 10 people) to ensure personalized attention, flexibility, and a more authentic experience.',
  color: 'from-cyan-400 to-cyan-600'
}];
export function WhyChooseUs() {
  return <section className="py-20 bg-gray-50" data-id="element-407">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-408">
        <SectionHeading title="Why Choose Us" subtitle="We go the extra mile to make your Himalayan journey exceptional." data-id="element-409" />

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-410">
          {reasons.map((reason, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.2
        }} className="bg-white p-8 rounded-2xl shadow-lg hover:shadow-xl transition-shadow duration-300 border border-gray-100 relative overflow-hidden group" data-id="element-411">
              <div className={`absolute top-0 right-0 w-32 h-32 bg-gradient-to-br ${reason.color} opacity-5 rounded-bl-full -mr-8 -mt-8 transition-transform group-hover:scale-110`} data-id="element-412" />

              <div className={`w-14 h-14 rounded-xl bg-gradient-to-br ${reason.color} flex items-center justify-center text-white mb-6 shadow-md group-hover:scale-110 transition-transform duration-300`} data-id="element-413">
                <reason.icon size={28} data-id="element-414" />
              </div>

              <h3 className="text-xl font-bold text-gray-900 mb-3" data-id="element-415">
                {reason.title}
              </h3>
              <p className="text-gray-600 leading-relaxed" data-id="element-416">
                {reason.description}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}